// Cycle-progress ZTile arrays are one flat list in row-major order:
// lane, then row, then column, then subtile. Tile names are zero-padded
// (L1R01C02S1), so that walk is numeric order of those fields.
// RunParameters.Tiles is a serpentine column walk and must not be used
// as this index space.

const TILE_NAME = /^L(\d+)R(\d+)C(\d+)S(\d+)$/i;

interface TileKey {
  lane: number;
  row: number;
  col: number;
  sub: number;
}

const tileKey = (name: string): TileKey | null => {
  const match = TILE_NAME.exec(name);
  if (!match) return null;
  return {
    lane: Number(match[1]),
    row: Number(match[2]),
    col: Number(match[3]),
    sub: Number(match[4]),
  };
};

const compareTileNames = (a: string, b: string): number => {
  const ka = tileKey(a);
  const kb = tileKey(b);
  if (!ka || !kb) return a < b ? -1 : a > b ? 1 : 0;
  return (
    ka.lane - kb.lane || ka.row - kb.row || ka.col - kb.col || ka.sub - kb.sub
  );
};

export const cycleProgressTileOrder = (tileNames: string[]): string[] =>
  [...tileNames].sort(compareTileNames);
